import './App.css';
import Board from './TicTacToeGame/Board';

function App() {
  return (
    <div className="App">
      <Board />
    </div>
  );
}

export default App;
